import * as R from 'ramda';
import { put, call } from 'redux-saga/effects';
// common
import { showRequestStatusModal } from '../../../common/actions';
// features
import { getAvailableDriverByGuidRequest } from '../../available-driver/actions';
import { getOrderCustomerInvoiceListRequest } from '../../dispatch-details/order/actions';
import { refreshPageRequest as refreshTelListPageRequest } from '../../dispatch-report/load/actions';
import { refreshPageRequest as refreshDispatchBoardLoadPageRequest } from '../../dispatch-board/load/actions';
import { refreshPageRequest as refreshTelByCloListPageRequest } from '../../dispatch-report/load/load-by-order/actions';
import {
  getItemListRequest as getFuelCards,
  resetListAndPagination as resetFuelCardListAndPagination,
} from '../../fuel-cards/actions';
import {
  getItemListRequest as getCarrierInvoices,
  resetListAndPagination as resetCarrierInvoiceListAndPagination,
} from '../../invoice/carrier/actions';
import {
  getItemListRequest as getCustomerInvoices,
  resetListAndPagination as resetCustomerInvoiceListAndPagination,
} from '../../invoice/customer/actions';
import {
  getItemListRequest as getServiceVendorInvoices,
  resetListAndPagination as resetServiceVendorInvoiceListAndPagination,
} from '../../invoice/service-vendor/actions';
import {
  getItemListRequest as getVendorInvoices,
  resetListAndPagination as resetVendorInvoiceListAndPagination,
} from '../../invoice/vendor/actions';
import {
  getItemListRequest as getDriverInvoices,
  resetListAndPagination as resetDriverInvoiceListAndPagination,
} from '../../invoice/driver/actions';
import {
  getItemListRequest as getMasterInvoices,
  resetListAndPagination as resetMasterInvoiceListAndPagination,
} from '../../master-invoice/actions';
import {
  getItemListRequest as getDriverPayrolls,
  resetListAndPagination as resetDriverPayrollListAndPagination,
} from '../../payroll/actions';
import {
  getItemListRequest as getVendorPayrolls,
  resetListAndPagination as resetVendorPayrollListAndPagination,
} from '../../payroll/vendor-payroll/actions';
import {
  getLoadDriverInvoiceListRequest,
  getLoadCarrierInvoiceListRequest,
  getLoadCustomerInvoiceListRequest,
  getServiceVendorInvoiceListRequest,
} from '../../dispatch-details/load/actions';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// feature sockets
import * as A from '../actions';
import * as C from '../constants';
//////////////////////////////////////////////////

const messageTypes = R.prop('genericMessageType', C);

function* handleGenericMessageReceived(payload, options) {
  const { data, socketDataType } = payload;

  switch (socketDataType) {
    case messageTypes.chatMessage:
      yield put(A.socketTelChatMessageReceived(payload));
      yield put(A.socketCarrierPortalReceived(payload));
      break;
    case messageTypes.loadStatus:
      yield put(A.socketTelLoadStatusReceived(data));
      break;
    case messageTypes.rateStatus:
      yield put(A.socketTelRateStatusReceived(data));
      break;
    case messageTypes.eventStatus:
      yield put(A.socketTelEventStatusReceived(payload));
      break;
    case messageTypes.statusMessage:
      yield put(A.socketTelStatusMessageReceived(payload));
      break;
    case messageTypes.document:
      yield put(A.socketTelDocumentReceived(payload));
      break;
    case messageTypes.costAllocation:
      yield put(A.socketTelCostAllocationsReceived(payload));
      break;
    case messageTypes.rate:
      yield put(A.socketTelRateReceived(payload));
      break;
    case messageTypes.cloStatusToTel:
      yield put(A.socketCloStatusToTelReceived(payload));
      break;
    case messageTypes.driverCardsTel:
      yield put(A.socketDriverCardsTelReceived(payload));
      break;
    case messageTypes.availableDriversNote:
      yield put(A.socketAvailableDriversNoteReceived(payload));
      break;
    case messageTypes.availableDriversComments:
      yield put(A.socketAvailableDriversCommentsReceived(payload));
      break;
    case messageTypes.availableDriversStatus:
      yield put(A.receiveAvailableDriversStatusSocket(payload));
      break;
    case messageTypes.availableDriversReservation:
      yield put(A.receiveAvailableDriversReservationSocket(payload));
      break;
    case messageTypes.availableDriversLastKnownLocation:
      yield put(A.socketAvailableDriversLocationReceived(payload));
      break;
    case messageTypes.availableDriversColor:
      yield put(A.socketAvailableDriversColorReceived(payload));
      break;
    case messageTypes.availableDriversTelInfo:
      yield put(getAvailableDriverByGuidRequest(payload));
      break;
    case messageTypes.generatedDocumentUrl:
      yield put(A.socketUserDocumentGeneratedReceivedSuccess(data));

      if (G.isString(data)) {
        yield call(G.showToastrMessage, 'info', data);
      } else {
        const url = R.path([GC.FIELD_DOCUMENT_URL], data);
        const fileName = R.path([GC.FIELD_DOCUMENT_DOCUMENT_NAME], data);

        if (R.isNil(window.amousSocketUserDocumentGeneratedReceived)) {
          window.amousSocketUserDocumentGeneratedReceived = [];
        }

        window.amousSocketUserDocumentGeneratedReceived.push({ url, fileName });
      }
      break;
    case messageTypes.ifta:
      const message = G.getWindowLocale('titles:ifta-report-competed', 'IFTA Report Completed');

      yield call(G.showToastrMessage, 'success', message);
      break;
    case messageTypes.ediExportResult:
    case messageTypes.exportToAccounting:
      const { type, status, totalCount, successCount, globalErrors } = data;

      const { loadGuid, orderGuid, componentType } = options;

      const errors = R.compose(
        R.values,
        R.mapObjIndexed((messageArray, key) => ({ key, messageArray })),
        R.pathOr({}, ['errors']),
      )(data);

      const currentPage = R.path(['location', 'pathname'], window);

      const isLoadPage = R.or(
        R.includes('route/load', currentPage),
        R.equals(componentType, GC.PAGE_DISPATCH_DETAILS_NEW_LOAD),
      );

      const isOrderPage = R.or(
        R.includes('route/order', currentPage),
        R.equals(componentType, GC.PAGE_DISPATCH_DETAILS_NEW_ORDER),
      );

      if (R.equals(type, 'CUSTOMER')) {
        if (R.equals(currentPage, GC.ROUTE_PATH_CUSTOMER_INVOICES_LIST)) {
          yield put(resetCustomerInvoiceListAndPagination());
          yield put(getCustomerInvoices(true));
        }

        if (isLoadPage) {
          yield put(getLoadCustomerInvoiceListRequest({ loadGuid }));
        }

        if (isOrderPage) {
          yield put(getOrderCustomerInvoiceListRequest({ [GC.FIELD_LOAD_GUID]: orderGuid }));
        }
      } else if (R.equals(type, 'FUEL_CARD_TRANSACTION')) {
        if (R.equals(currentPage, GC.ROUTE_PATH_FUEL_CARDS)) {
          yield put(resetFuelCardListAndPagination());
          yield put(getFuelCards(true));
        }
      } else if (R.equals(type, 'CARRIER')) {
        if (R.equals(currentPage, GC.ROUTE_PATH_CARRIER_INVOICES_LIST)) {
          yield put(resetCarrierInvoiceListAndPagination());
          yield put(getCarrierInvoices(true));
        }

        if (isLoadPage) {
          yield put(getLoadCarrierInvoiceListRequest({ loadGuid }));
        }
      } else if (R.equals(type, 'SERVICE_VENDOR')) {
        if (R.equals(currentPage, GC.ROUTE_PATH_SERVICE_VENDOR_INVOICE_LIST)) {
          yield put(resetServiceVendorInvoiceListAndPagination());
          yield put(getServiceVendorInvoices(true));
        }

        if (isLoadPage) {
          yield put(getServiceVendorInvoiceListRequest({ loadGuid }));
        }
      } else if (R.equals(type, 'FLEET_VENDOR')) {
        if (R.equals(currentPage, GC.ROUTE_PATH_VENDOR_INVOICES_LIST)) {
          yield put(resetVendorInvoiceListAndPagination());
          yield put(getVendorInvoices(true));
        }

        if (isLoadPage) {
          yield put(getLoadDriverInvoiceListRequest({ loadGuid }));
        }
      } else if (R.equals(type, 'DRIVER')) {
        if (R.equals(currentPage, GC.ROUTE_PATH_DRIVER_INVOICES_LIST)) {
          yield put(resetDriverInvoiceListAndPagination());
          yield put(getDriverInvoices(true));
        }

        if (isLoadPage) {
          yield put(getLoadDriverInvoiceListRequest({ loadGuid }));
        }
      } else if (R.and(
        R.equals(type, 'MASTER_INVOICE'),
        R.equals(currentPage, GC.ROUTE_PATH_CUSTOMER_MASTER_INVOICE_LIST),
      )) {
        yield put(resetMasterInvoiceListAndPagination());
        yield put(getMasterInvoices(true));
      } else if (R.and(
        R.equals(type, 'DRIVER_PAYROLL'),
        R.equals(currentPage, GC.ROUTE_PATH_DRIVER_PAYROLL_LIST),
      )) {
        yield put(resetDriverPayrollListAndPagination());
        yield put(getDriverPayrolls(true));
      } else if (R.and(
        R.equals(type, 'VENDOR_PAYROLL'),
        R.equals(currentPage, GC.ROUTE_PATH_DRIVER_PAYROLL_LIST),
      )) {
        yield put(resetVendorPayrollListAndPagination());
        yield put(getVendorPayrolls(true));
      }

      const exportResultTypeLocaleArr = G.ifElse(
        R.equals(socketDataType, messageTypes.ediExportResult),
        ['titles:edi', 'EDI'],
        ['titles:accounting', 'Accounting'],
      );

      const title = `${G.getWindowLocale(...exportResultTypeLocaleArr)} ${
        G.getWindowLocale('titles:export-result', 'Export Result')}`;

      yield put(showRequestStatusModal({
        title,
        status,
        errors,
        totalCount,
        successCount,
        globalErrors,
      }));
      break;
    case messageTypes.frontError:
    case messageTypes.generalError:
    case messageTypes.cloCreateError:
    case messageTypes.macroPointError:
    case messageTypes.masterInvoiceExportError:
    case messageTypes.carrierLoadBoardSyncError:
      console.log('//////////////////// SOCKET_FRONT_ERROR', socketDataType, payload, '////////////////////');
      break;
    case messageTypes.massDispatch:
      const pathname = G.getWindowLocationPathname();

      if (R.equals(pathname, GC.ROUTE_PATH_DISPATCH_BOARD_TEL)) {
        yield put(refreshDispatchBoardLoadPageRequest());
      } else if (R.equals(pathname, GC.ROUTE_PATH_CENTRALIZED_DISPATCH)) {
        yield put(refreshDispatchBoardLoadPageRequest({ centralizedDispatch: true }));
      } else if (R.equals(pathname, GC.ROUTE_PATH_TEL_REPORT_LIST)) {
        yield put(refreshTelListPageRequest());
        yield put(refreshTelByCloListPageRequest());
      }

      const massDispatchTitle = `${G.getWindowLocale('titles:mass-dispatch', 'Mass Dispatch')} ${
        G.getWindowLocale('titles:result', 'Result')}`;

      const mappedErrors = R.compose(
        R.values,
        R.mapObjIndexed((messageArray, key) => ({ key, messageArray })),
        R.propOr([], ['errors']),
      )(data);

      yield put(showRequestStatusModal({
        ...data,
        errors: mappedErrors,
        title: massDispatchTitle,
      }));

      break;
    default:
  }
}

export default handleGenericMessageReceived;
